export default __webpack_public_path__ + "static/media/icon_trbo.0bda079a.svg";